/**
 * Window CustomEvent fired whenever a comment thread's content or read state
 * changes (own post, read receipt, ack, incoming socket event). ONE owner for
 * the name: the drawer button, the list-row chips, the sidebar pill, the
 * dashboard widget and the Discussions page all listen to it; the thread
 * dispatches it with a full `{ parentType, parentId }` detail.
 */
export const COMMENTS_CHANGED_EVENT = "crx:comments-changed";

export interface CommentsChangedDetail {
    parentType?: string;
    parentId?: number;
}

/** Dispatch with an optional detail — listeners refetch when it matches or is absent. */
export const notifyCommentsChanged = (parentType?: string, parentId?: number): void => {
    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
    window.dispatchEvent(new CustomEvent<CommentsChangedDetail>(COMMENTS_CHANGED_EVENT, {
        detail: { parentType, parentId },
    }));
};

/** Thread-side alias: always carries a full detail. */
export function dispatchCommentsChanged(parentType: string, parentId: number): void {
    notifyCommentsChanged(parentType, parentId);
}
